import { cx } from '@/utils/strings'

type SectionProps = {
  children: React.ReactNode
  className?: string
}

export default function Section({ className, children }: SectionProps) {
  return <div className={cx(className, `relative z-1 px-8 mb-24 md:px-28 md:mb-40 [&_svg]:fill-none`)}>{children}</div>
}
